<template>
  <div class="expire_tips">
    <div class="content">
      <bxs-default-page type="empty" :responsive="false" :text="textTips" />
      <div v-if="isApp">
        <bxs-button @click="gotoPlanbookIndex">
          去作计划书
        </bxs-button>
      </div>
      <div v-if="!isApp && agentInfo" class="agent_info">
        <p v-if="agentInfo.name">
          {{ agentInfo.name }}
        </p>
        <a v-if="agentInfo.telephone" :href="`tel: ${agentInfo.telephone}`">
          手机号：<span>{{ agentInfo.telephone }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Jax from '@bxs/jax'
import { appScheme } from 'common/utils/variables'
import { getNewCard } from 'api/index'
import { getUrlParam } from 'common/js/common'
import { Button, DefaultPage } from 'bxs-ui-vue'
import Vue from 'vue'
Vue.use(DefaultPage)
export default {
  components: {
    [Button.name]: Button,
    [DefaultPage.name]: DefaultPage
  },
  props: {
    plainResultData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      isApp: Jax.isApp(),
      pbType: getUrlParam('pbType'),
      userUuid: getUrlParam('cardUuid'),
      appId: getUrlParam('appId'),
      agentInfo: null
    }
  },
  computed: {
    textTips () {
      return this.isApp ? '计划书已过期，您可以重新制作计划书' : '分享链接已过期，有问题可以询问代理人'
    }
  },
  created () {
    const { plainResultData, pbType } = this
    appBridge.hideLoading()
    if (plainResultData) {
      const { status, createTime, visitTimes } = plainResultData
      if (status === 'expire') {
        setTimeout(() => {
          window.WeiyiStatSDK.submit('gq', {
            type: pbType === 'annual_survey' ? 'BDNJ' : 'JGY',
            time: createTime,
            visitTimes
          })
        }, 3000)
      }
    }
    this.getNewCard()
  },
  methods: {
    gotoPlanbookIndex () {
      location.href = `${appScheme}planbook/home`
    },
    getNewCard() {
      if (this.isApp) {
        return
      }
      return getNewCard({
        userUuid: this.userUuid,
        appId: this.appId
      }).then((res) => {
        const { success, data } = res.data
        if(!success || !data) {
          return
        }
        this.agentInfo = data
      })
    }
  }
}
</script>
<style>
.expire_tips {
  position: relative;
  background: white;
  height: 100vh;
  font-size: 14px;
  text-align: center;
  & .content {
    position: absolute;
    top: 30%;
    transform: translateY(-50%);
    width: 100%;
    & .agent_info {
      text-align: center;
      & p {
        margin-bottom: 9px;
      }
      & a {
        display: block;
        margin-bottom: 9px;
        & span {
          color: var(--primary-color);
          text-decoration-line: underline;
        }
      }
    }
  }
}
</style>
